"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _DataResponse = _interopRequireDefault(require("../models/DataResponse"));

var _DataSecurableResponse = _interopRequireDefault(require("../models/DataSecurableResponse"));

/**
 * Role service.
 * @module ChiRhos/api/RoleApi
 * @version v1
 */
var RoleApi =
/*#__PURE__*/
function () {
  /**
   * Constructs a new RoleApi.
   * @alias module:ChiRhos/api/RoleApi
   * @class
   * @param {module:ChiRhos/ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ChiRhos/ApiClient#instance} if unspecified.
   */
  function RoleApi(apiClient) {
    (0, _classCallCheck2["default"])(this, RoleApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * @param {Object} opts Optional parameters
   * @param {String} opts.entityId
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  (0, _createClass2["default"])(RoleApi, [{
    key: "_deleteWithHttpInfo",
    value: function _deleteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Role', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Delete",
    value: function Delete(opts) {
      return this._deleteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_getWithHttpInfo",
    value: function _getWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Role/Get', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Get",
    value: function Get(opts) {
      return this._getWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * This helper will give all roles within the current organization that contains the given group type
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_listAllForOrganizationContainingWithHttpInfo",
    value: function _listAllForOrganizationContainingWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Role/ListAllForOrganizationContaining', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * This helper will give all roles within the current organization that contains the given group type
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "ListAllForOrganizationContaining",
    value: function ListAllForOrganizationContaining(opts) {
      return this._listAllForOrganizationContainingWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityWithDeletedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_listForGroupTypeWithHttpInfo",
    value: function _listForGroupTypeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Role/ListForGroupType', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityWithDeletedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "ListForGroupType",
    value: function ListForGroupType(opts) {
      return this._listForGroupTypeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/RoleConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_saveWithHttpInfo",
    value: function _saveWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Role', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/RoleConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Save",
    value: function Save(opts) {
      return this._saveWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_restoreWithHttpInfo",
    value: function _restoreWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Role/Restore', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Restore",
    value: function Restore(opts) {
      return this._restoreWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
  }]);
  return RoleApi;
}();

exports["default"] = RoleApi;
module.exports = exports.default;